import { render, staticRenderFns } from "./ManterMinutaEditar.vue?vue&type=template&id=223f32e7&scoped=true&"
import script from "./ManterMinutaEditar.vue?vue&type=script&lang=js&"
export * from "./ManterMinutaEditar.vue?vue&type=script&lang=js&"
import style0 from "./ManterMinutaEditar.vue?vue&type=style&index=0&id=223f32e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f32e7",
  null
  
)

export default component.exports